import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { map, filter, withLatestFrom } from 'rxjs/operators';
import { TakedownRelease } from '@webapp/store/release/action-creators';
import { TAKEDOWN_RELEASE } from '@webapp/store/release/actions';
import { trackList } from '@webapp/store/tracks/selectors';
import AppState from '@webapp/store/state';
import {
  collaboratorsList,
  contributorsList,
} from '@webapp/store/collaborator/selectors';
import { ownersList, writersList } from '@webapp/store/ownership/selectors';
import { rudderTrack } from '@webapp/utils/rudderstack/init';

export const trackReleaseRemoved = (
  action$: Observable<TakedownRelease>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType(TAKEDOWN_RELEASE),
    withLatestFrom(state$),
    map(([action, state]) => {
      if (window.analytics) {
        window.analytics.track('Release Takendown', {
          release_id: action.releaseId,
          delisted_by: 'User',
        });
      }

      const tracks = trackList(state.tracks.tracks, state.release.release?.id);

      const songs = tracks.map((track) => {
        const collaborators = collaboratorsList(
          state.collaborator,
          track.id as string
        )
          .filter((a) => a.role === 'main' || a.role === 'featuring')
          .map((a) => {
            return {
              name: a.name || a.contact,
              artist_id: a?.collaboratorId ?? '',
              role: a?.role ?? '',
            };
          });

        const owners = ownersList(state.ownership, track.id as string).map(
          (o) => {
            return {
              name: o.name,
              artist_id: o.ownerId,
              split: o.split,
            };
          }
        );

        const songwriters = writersList(
          state.ownership,
          track.id as string
        ).map((w) => {
          return {
            name: w.name,
            artist_id: w.ownerId,
            split: w.split,
          };
        });

        const credits = contributorsList(
          state.collaborator,
          track.id as string
        ).map((c) => {
          return {
            name: c.name,
            artist_id: c.collaboratorId,
            role: c?.role ?? '',
          };
        });

        return {
          name: track.title,
          track_version: track.trackVersion,
          instrumental: track.type,
          explicit: track.isExplicit,
          lyrics: track.lyrics,
          language: track.language,
          isrc: track.isrc,
          instant_gratification: track.isInstantGratification,
          copyright_status: track.ownProduced,
          collaborators,
          owners,
          songwriters,
          credits,
        };
      });

      rudderTrack('Release Completed', {
        releaseId: state.release.release?.id,
        artistId: state.artist.active?.id,
        releaseName: state.release.release?.title,
        artistName: state.artist.active?.name,
        release_date: state.release.release?.releaseDate,
        songs,
      });
    }),
    filter(() => false)
  );
